export default {
    parent: null,
    items: [],
    current: null,
    allowAdd: true,
    proposal: 'Add {X} to the list?',
    notFound: '{X} not present in the list',
    allowRemove: true,
    removalIcon: '&times;',
    placeHolder: 'Type to search',
    sort: true,
    order: 'desc',
    maxHeight: 0,
    onDelete: null,
    onCreate: null,
    valueKey: 'value',
    textKey: 'value'
}
